import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Skeleton } from '@mui/material';
import useStyles from './styles';
export default function BuildingsTableLoader() {
  const classes = useStyles();
  const dataRows = 10;
  return /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "loader table",
    size: "small",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.firstCell
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48,
    width: 360
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 48
  })))), /*#__PURE__*/React.createElement(TableBody, null, [...Array(dataRows)].map((elem, index) => /*#__PURE__*/React.createElement(TableRow, {
    key: index
  }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 24
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.statusField
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 76
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.addressField
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24,
    width: 230
  })))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 24
  })), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.lastCell
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 36,
    width: 36
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 36,
    width: 95
  })))))))));
}